import { render, staticRenderFns } from "./LyndaReportAttachment.vue?vue&type=template&id=f2762516"
import script from "./LyndaReportAttachment.vue?vue&type=script&lang=js"
export * from "./LyndaReportAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports